module.exports = __webpack_public_path__ + "img/20210906-1630912440782056.241f777b.png";